import { EOAuthType } from '../enums';
// Maps each OAuth service to its icon name. The icon files are shared (core/static),
// so the literal values match both the web (TSvgName) and mobile (TIconName) icon sets.
// `as const` keeps the values as string literals so they stay assignable to those types.
export const OAUTH_ICONS = {
    [EOAuthType.Dropbox]: 'Dropbox',
    [EOAuthType.Twitter]: 'Twitter',
    [EOAuthType.Google]: 'Google',
    [EOAuthType.ProtonMail]: 'Proton',
    [EOAuthType.Oura]: 'Oura',
    [EOAuthType.EightSleep]: 'EightSleep',
    [EOAuthType.Renpho]: 'Renpho'
};
//# sourceMappingURL=oauth.constants.js.map